export function DataCard({ Icon, title, value, resumeLink }) {

    return (
        <div className='p-3 rounded-lg shadow flex gap-3 items-center my-2 bg-white'>
            <span className="bg-blue-100 text-primary-300 p-2 text-3xl rounded-full flex items-center justify-center">
                <Icon />
            </span>

            <div>
                <h6 className="text-slate-700 text-sm">{title || ""}</h6>
                <p className="font-medium text-slate-900 text-sm">{value || ""}</p>
            </div>
        </div>
    )
}